/**
 * 绘制3d图
 * @param pieData 总数据
 * @param internalDiameterRatio:透明的空心占比
 * @param distance 视角到主体的距离
 * @param alpha 旋转角度
 * @param pieHeight 立体的高度
 * @param opacity 饼或者环的透明度
 * @param bottomOpacity 底部圆(第一个)透明度
 * @param coefficient 底部圆的面积系数
 * @param isSeparatePie 是否是分离饼状图
 * @param marginLeft 饼图离左侧边距
 * @param unit 单位 （默认人）
 */
// import { getFilterMoney } from '@/filters'
// 生成模拟 3D 饼图的配置项
// pieData（object）：饼图数据
// internalDiameterRatio（0~1之间的浮点数）：内径/外径的值（默认值 1/2），当该值等于 0 时，
// heigth配置每个数据生成的高度
const getPie3D = (pieData, internalDiameterRatio, distance, alpha, pieHeight, opacity = 0, bottomOpacity = 0.35, coefficient = 2, isSeparatePie = false, marginLeft = '-6%', marginTop = '20%', unit = '人') => {
  let series = []
  let sumValue = 0
  let startValue = 0
  let endValue = 0
  let legendData = []
  let legendBfb = []
  let ratio = []
  // let linesSeries = []; // line3D模拟label指示线

  const k = 1 - internalDiameterRatio
  pieData.sort((a, b) => {
    return b.value - a.value
  })
  // 为每一个饼图数据，生成一个 series-surface 配置
  for (let i = 0; i < pieData.length; i++) {
    sumValue += pieData[i].value
    const seriesItem = {
      name:
          typeof pieData[i].name === 'undefined'
            ? `series${i}`
            : pieData[i].name,
      type: 'surface',
      parametric: true,
      wireframe: {
        show: false
      },
      pieData: pieData[i],
      pieStatus: {
        selected: false,
        hovered: false,
        k: k
      },
      // center: ['50%', '50%']
    }
    if (typeof pieData[i].itemStyle !== 'undefined') {
      const itemStyle = {}
      itemStyle.color =
          typeof pieData[i].itemStyle.color !== 'undefined'
            ? pieData[i].itemStyle.color
            : opacity
      itemStyle.opacity =
          typeof pieData[i].itemStyle.opacity !== 'undefined'
            ? pieData[i].itemStyle.opacity
            : opacity
      seriesItem.itemStyle = itemStyle
    }
    series.push(seriesItem)
  }
  for(let i = 0; i < pieData.length; i++) {
    ratio.push(pieData[i].value / sumValue);
  }

  // 使用上一次遍历时，计算出的数据和 sumValue，调用 getParametricEquation 函数，
  // 向每个 series-surface 传入不同的参数方程 series-surface.parametricEquation，也就是实现每一个扇形。
  legendData = []
  legendBfb = []
  for (let i = 0; i < series.length; i++) {
    endValue = startValue + series[i].pieData.value
    series[i].pieData.startRatio = startValue / sumValue
    series[i].pieData.endRatio = endValue / sumValue
    series[i].parametricEquation = getParametricEquation(
      series[i].pieData.startRatio,
      series[i].pieData.endRatio,
      isSeparatePie,
      false,
      k,
      isSeparatePie ? 10 : series[i].pieData.value,
      i,
      isSeparatePie,
    )
    startValue = endValue;
    const bfb = formatFloat(series[i].pieData.value / sumValue, 4)
    legendData.push({
      name: series[i].name,
      value: bfb
    })
    legendBfb.push({
      name: series[i].name,
      value: bfb
    })


    // 计算label指示线的起始和终点位置
    // 计算扇区中心角度（弧度）
    // const midRadian = (series[i].pieData.startRatio + series[i].pieData.endRatio) * Math.PI;
    // // 计算扇区外缘顶部坐标（v=0时）
    // const radius = 1 + k; // 外径公式
    // const posX = Math.cos(midRadian) * radius;
    // const posY = Math.sin(midRadian) * radius;
    // // 获取该扇区实际高度
    // const posZ = 0.3 * series[i].pieData.value; 
    // let flag = ((midRadian >= 0 && midRadian <= Math.PI / 2) || (midRadian >= 3 * Math.PI / 2 && midRadian <= Math.PI * 2)) ? 1 : -1;
    // let color = pieData[i].itemStyle.color;
    // let turningPosArr = [
    //     posX * (1.1) + (i * 0.1 * flag) + (flag < 0 ? -0.2 : 0), 
    //     posY * (1.1) + (i * 0.1 * flag) + (flag < 0 ? -0.2 : 0), 
    //     posZ * (1)
    // ]
    // let endPosArr = [
    //     posX * (1.2) + (i * 0.1 * flag) + (flag < 0 ? -0.2 : 0), 
    //     posY * (1.2) + (i * 0.1 * flag) + (flag < 0 ? -0.2 : 0), 
    //     posZ * (3)
    // ]

    // linesSeries.push({
    //   type: 'line3D',
    //   lineStyle: {
    //       color: '#FFFFFF',
    //   },
    //   data: [[posX, posY, posZ], turningPosArr, endPosArr]
    // })
  }
  let boxHeight = getHeight3D(series, pieHeight) // 通过pieHeight设定3d饼/环的高度，单位是px
  series.push({
    name: 'mouseoutSeries',
    type: 'surface',
    parametric: true,
    wireframe: {
        show: false,
    },
    itemStyle: {
        opacity: bottomOpacity,
        // color: 'rgba(25, 93, 176, 1)',
        color: 'rgb(68, 214, 119)',
        // color: 'red',
    },
    parametricEquation: {
        u: {
            min: 0,
            max: Math.PI * 6,
            step: 0.1,
        },
        v: {
            min: 0,
            max: Math.PI * 6,
            step: 0.1,
        },
        x: function (u, v) {
            return ((Math.sin(v) * Math.sin(u) + Math.sin(u)) / Math.PI) * coefficient;
        },
        y: function (u, v) {
            return ((Math.sin(v) * Math.cos(u) + Math.cos(u)) / Math.PI) * coefficient;
        },
        z: function (u, v) {
            // return Math.cos(v) > 0 ? -0 : -1.5;
            return -1.1
        },
    },
  });
  // 最底下圆盘
  series.push({
    name: 'mouseoutSeries',
    type: 'surface',
    parametric: true,
    wireframe: {
        show: false,
    },
    itemStyle: {
        opacity: 0.05,
        // color: 'rgba(25, 93, 176, 1)',
        color: '#44d677',
    },
    parametricEquation: {
        u: {
            min: 0,
            max: Math.PI * 4,
            step: 0.1,
        },
        v: {
            min: 0,
            max: Math.PI * 4,
            step: 0.1,
        },
        x: function (u, v) {
            return ((Math.sin(v) * Math.sin(u) + Math.sin(u)) / Math.PI) * coefficient * 1.1;
        },
        y: function (u, v) {
            return ((Math.sin(v) * Math.cos(u) + Math.cos(u)) / Math.PI) * coefficient * 1.1;
        },
        z: function (u, v) {
            // return Math.cos(v) > 0 ? -0 : -1.5;
            return -1.3
        },
    },
  });
  // boxHeight = pieHeight;
  // series = series.concat(linesSeries);
  // 准备待返回的配置项，把准备好的 legendData、series 传入。
  const option = {
    legend: {
      show: false,
      data: legendData,
      orient: 'vertical',
      left: 10,
      top: 10,
      itemGap: 10,
      textStyle: {
        color: '#A1E2FF'
      },
      icon: 'circle',
      formatter: function (param) {
        const item = legendBfb.filter(item => item.name === param)[0]
        const bfs = formatFloat(item.value * 100, 2) + '%'
        return `${item.name}  ${bfs}`
      }
    },
    labelLine: {
      show: true,
      // lineStyle: {
      //   color: 'red'
      // }
    },
    label: {
      show: true,
      position: 'inside',
      formatter: '{b} \n{c} {d}%'
    },
    tooltip: {
      backgroundColor: 'rgba(5, 51, 21, 0.7)',
      borderColor: '#21f2c4',
      textStyle: {
        color: '#fff',
        fontSize: 13
      },
      formatter: params => {
        if (
          params.seriesName !== 'mouseoutSeries' &&
            params.seriesName !== 'pie2d' &&
            params.seriesType !== 'pie'
        ) {
          if (option.series[params.seriesIndex].pieData) {
            const bfb = (
              (option.series[params.seriesIndex].pieData.endRatio -
                  option.series[params.seriesIndex].pieData.startRatio) *
                100
            ).toFixed(2)
            return (
              `${params.seriesName}<br/>` +
              `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${params.color};"></span>` +
              // `${bfb}% ${getFilterMoney(series[params.seriesIndex].pieData.value)}`
              `${bfb}% ${series[params.seriesIndex].pieData.value}${unit}`
            )
          }
        }
      }
    },
    xAxis3D: {
      min: -1,
      max: 1
    },
    yAxis3D: {
      min: -1,
      max: 1
    },
    zAxis3D: {
      min: -1,
      max: 1
    },
    grid3D: {
      show: false,
      // boxHeight: boxHeight, // 圆环的高度
      // boxHeight: isSeparatePie ? 14 : 52, // 圆环的高度
      boxHeight: isSeparatePie ? 14 : boxHeight, // 圆环的高度
      top: marginTop,
      // bottom: '20',
      // left: '-6%',
      left: marginLeft,
      viewControl: {
        projection: isSeparatePie ? 'perspective' : 'orthographic',
        orthographicSize: distance, // 正交投影的大小
        // 3d效果可以放大、旋转等，请自己去查看官方配置
        alpha, // 角度
        distance, // 调整视角到主体的距离，类似调整zoom
        rotateSensitivity: 0, // 设置为0无法旋转
        zoomSensitivity: 0, // 设置为0无法缩放
        panSensitivity: 0, // 设置为0无法平移
        autoRotate: false // 自动旋转
      }
    },
    series: series
  }
  if(isSeparatePie) {
    option.grid3D.viewControl.beta = -10 * ratio[1] *15;
  }
  return option
}


/**
 *生成扇形的曲面参数方程，用于 series-surface.parametricEquation
 * @param isSeparatePie 是否是分离饼状图
 * @param i 第几个，修改z轴
 */
 const getParametricEquation = (startRatio, endRatio, isSelected, isHovered, k, h, i, isSeparatePie=false) => {
	// 计算
	let midRatio = (startRatio + endRatio) / 2;

	let startRadian = startRatio * Math.PI * 2;
	let endRadian = endRatio * Math.PI * 2;
	let midRadian = midRatio * Math.PI * 2;

	// 如果只有一个扇形，则不实现选中效果。
	if (startRatio === 0 && endRatio === 1) {
		isSelected = false;
	}

	// 通过扇形内径/外径的值，换算出辅助参数 k（默认值 1/3）
	k = typeof k !== "undefined" ? k : 1 / 3;

	// 计算选中效果分别在 x 轴、y 轴方向上的位移（未选中，则位移均为 0）
	let offsetX = isSelected ? Math.cos(midRadian) * 0.1 : 0;
	let offsetY = isSelected ? Math.sin(midRadian) * 0.1 : 0;
	// let offsetZ = i == 1 ? 1: 0;
	let offsetZ = 0;
	if(isSeparatePie){
		offsetZ = i == 1 ? 1: 0;
	}
	// 计算高亮效果的放大比例（未高亮，则比例为 1）
	let hoverRate = isHovered ? 1.05 : 1;

	// 返回曲面参数方程
	return {
		u: {
			min: -Math.PI,
			max: Math.PI * 3,
			step: Math.PI / 32
		},

		v: {
			min: 0,
			max: Math.PI * 2,
			step: Math.PI / 20
		},

		x: function(u, v) {
			if (u < startRadian) {
				return (
					offsetX +
					Math.cos(startRadian) * (1 + Math.cos(v) * k) * hoverRate
				);
			}
			if (u > endRadian) {
				return (
					offsetX + Math.cos(endRadian) * (1 + Math.cos(v) * k) * hoverRate
				);
			}
			return offsetX + Math.cos(u) * (1 + Math.cos(v) * k) * hoverRate;
		},

		y: function(u, v) {
			if (u < startRadian) {
				return (
					offsetY +
					Math.sin(startRadian) * (1 + Math.cos(v) * k) * hoverRate
				);
			}
			if (u > endRadian) {
				return (
					offsetY + Math.sin(endRadian) * (1 + Math.cos(v) * k) * hoverRate
				);
			}
			return offsetY + Math.sin(u) * (1 + Math.cos(v) * k) * hoverRate;
		},

		z: function(u, v) {
			if (u < -Math.PI * 0.5) {
				return offsetZ + Math.sin(u);
			}
			if (u > Math.PI * 2.5) {
				return offsetZ + Math.sin(u) * h * 0.1
			}
			// 调整扇形高度
			return offsetZ + (Math.sin(v) > 0 ? 0.1 * h : -1);
		}
	};
}

/**
 * 获取3d丙图的最高扇区的高度
 */
 const getHeight3D = (series, height) => {
  series.sort((a, b) => {
    return b.pieData.value - a.pieData.value
  })
  // return (height * 25) / series[0].pieData.value;
  return Math.min(18, (height * 25) / series[0].pieData.value);
}

/**
 * 格式化浮点数
 */
const formatFloat = (num, n) => {
  let f = parseFloat(num)
  if (isNaN(f)) {
    return false
  }
  f = Math.round(num * Math.pow(10, n)) / Math.pow(10, n) // n 幂
  let s = f.toString()
  let rs = s.indexOf('.')
  // 判定如果是整数，增加小数点再补0
  if (rs < 0) {
    rs = s.length
    s += '.'
  }
  while (s.length <= rs + n) {
    s += '0'
  }
  return s
}


export { getPie3D, getParametricEquation }
